var render, staticRenderFns
import script from "./ProjectPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectPage.vue"
export default component.exports